export default "__VITE_ASSET__BBYZjkid__"